enum Hemisphere {
  Northern,
  Sourthern,
  Equatorial,
}

interface Country {
  id: string;
  label: string;
  hemisphere: Hemisphere;
}

export const countries: Country[] = [
  {
    id: 'AF',
    label: 'Afghanistan',
    hemisphere: 0,
  },
  {
    id: 'AL',
    label: 'Albania',
    hemisphere: 0,
  },
  {
    id: 'DZ',
    label: 'Algeria',
    hemisphere: 0,
  },
  {
    id: 'AD',
    label: 'Andorra',
    hemisphere: 0,
  },
  {
    id: 'AO',
    label: 'Angola',
    hemisphere: 1,
  },
  {
    id: 'AG',
    label: 'Antigua and Barbuda',
    hemisphere: 0,
  },
  {
    id: 'AR',
    label: 'Argentina',
    hemisphere: 1,
  },
  {
    id: 'AM',
    label: 'Armenia',
    hemisphere: 0,
  },
  {
    id: 'AU',
    label: 'Australia',
    hemisphere: 1,
  },
  {
    id: 'AT',
    label: 'Austria',
    hemisphere: 0,
  },
  {
    id: 'AZ',
    label: 'Azerbaijan',
    hemisphere: 0,
  },
  {
    id: 'BS',
    label: 'Bahamas',
    hemisphere: 0,
  },
  {
    id: 'BH',
    label: 'Bahrain',
    hemisphere: 0,
  },
  {
    id: 'BD',
    label: 'Bangladesh',
    hemisphere: 0,
  },
  {
    id: 'BB',
    label: 'Barbados',
    hemisphere: 0,
  },
  {
    id: 'BY',
    label: 'Belarus',
    hemisphere: 0,
  },
  {
    id: 'BE',
    label: 'Belgium',
    hemisphere: 0,
  },
  {
    id: 'BZ',
    label: 'Belize',
    hemisphere: 0,
  },
  {
    id: 'BJ',
    label: 'Benin',
    hemisphere: 0,
  },
  {
    id: 'BT',
    label: 'Bhutan',
    hemisphere: 0,
  },
  {
    id: 'BO',
    label: 'Bolivia',
    hemisphere: 1,
  },
  {
    id: 'BA',
    label: 'Bosnia and Herzegovina',
    hemisphere: 0,
  },
  {
    id: 'BW',
    label: 'Botswana',
    hemisphere: 1,
  },
  {
    id: 'BR',
    label: 'Brazil',
    hemisphere: 2,
  },
  {
    id: 'BN',
    label: 'Brunei',
    hemisphere: 0,
  },
  {
    id: 'BG',
    label: 'Bulgaria',
    hemisphere: 0,
  },
  {
    id: 'BF',
    label: 'Burkina Faso',
    hemisphere: 0,
  },
  {
    id: 'BI',
    label: 'Burundi',
    hemisphere: 0,
  },
  {
    id: 'KH',
    label: 'Cambodia',
    hemisphere: 0,
  },
  {
    id: 'CM',
    label: 'Cameroon',
    hemisphere: 0,
  },
  {
    id: 'CA',
    label: 'Canada',
    hemisphere: 0,
  },
  {
    id: 'CV',
    label: 'Cape Verde',
    hemisphere: 0,
  },
  {
    id: 'CF',
    label: 'Central African Republic',
    hemisphere: 0,
  },
  {
    id: 'TD',
    label: 'Chad',
    hemisphere: 0,
  },
  {
    id: 'CL',
    label: 'Chile',
    hemisphere: 1,
  },
  {
    id: 'CN',
    label: 'China',
    hemisphere: 0,
  },
  {
    id: 'CO',
    label: 'Colombia',
    hemisphere: 1,
  },
  {
    id: 'KM',
    label: 'Comoros',
    hemisphere: 0,
  },
  {
    id: 'CD',
    label: 'Democratic Republic of Congo',
    hemisphere: 0,
  },
  {
    id: 'CG',
    label: 'Republic of Congo',
    hemisphere: 0,
  },
  {
    id: 'CR',
    label: 'Costa Rica',
    hemisphere: 0,
  },
  {
    id: 'CI',
    label: "Côte d'Ivoire",
    hemisphere: 0,
  },
  {
    id: 'HR',
    label: 'Croatia',
    hemisphere: 0,
  },
  {
    id: 'CU',
    label: 'Cuba',
    hemisphere: 0,
  },
  {
    id: 'CY',
    label: 'Cyprus',
    hemisphere: 0,
  },
  {
    id: 'CZ',
    label: 'Czech Republic',
    hemisphere: 0,
  },
  {
    id: 'DK',
    label: 'Denmark',
    hemisphere: 0,
  },
  {
    id: 'DJ',
    label: 'Djibouti',
    hemisphere: 0,
  },
  {
    id: 'DM',
    label: 'Dominica',
    hemisphere: 0,
  },
  {
    id: 'DO',
    label: 'Dominican Republic',
    hemisphere: 0,
  },
  {
    id: 'TL',
    label: 'Timor-Leste',
    hemisphere: 0,
  },
  {
    id: 'EC',
    label: 'Ecuador',
    hemisphere: 0,
  },
  {
    id: 'EG',
    label: 'Egypt',
    hemisphere: 0,
  },
  {
    id: 'SV',
    label: 'El Salvador',
    hemisphere: 0,
  },
  {
    id: 'GQ',
    label: 'Equatorial Guinea',
    hemisphere: 2,
  },
  {
    id: 'ER',
    label: 'Eritrea',
    hemisphere: 0,
  },
  {
    id: 'EE',
    label: 'Estonia',
    hemisphere: 0,
  },
  {
    id: 'ET',
    label: 'Ethiopia',
    hemisphere: 0,
  },
  {
    id: 'FJ',
    label: 'Fiji',
    hemisphere: 1,
  },
  {
    id: 'FI',
    label: 'Finland',
    hemisphere: 0,
  },
  {
    id: 'FR',
    label: 'France',
    hemisphere: 0,
  },
  {
    id: 'GA',
    label: 'Gabon',
    hemisphere: 0,
  },
  {
    id: 'GM',
    label: 'Gambia',
    hemisphere: 0,
  },
  {
    id: 'GE',
    label: 'Georgia',
    hemisphere: 0,
  },
  {
    id: 'DE',
    label: 'Germany',
    hemisphere: 0,
  },
  {
    id: 'GH',
    label: 'Ghana',
    hemisphere: 0,
  },
  {
    id: 'GR',
    label: 'Greece',
    hemisphere: 0,
  },
  {
    id: 'GD',
    label: 'Grenada',
    hemisphere: 0,
  },
  {
    id: 'GT',
    label: 'Guatemala',
    hemisphere: 0,
  },
  {
    id: 'GN',
    label: 'Guinea',
    hemisphere: 0,
  },
  {
    id: 'GW',
    label: 'Guinea-Bissau',
    hemisphere: 0,
  },
  {
    id: 'GY',
    label: 'Guyana',
    hemisphere: 0,
  },
  {
    id: 'HT',
    label: 'Haiti',
    hemisphere: 0,
  },
  {
    id: 'HN',
    label: 'Honduras',
    hemisphere: 0,
  },
  {
    id: 'HU',
    label: 'Hungary',
    hemisphere: 0,
  },
  {
    id: 'IS',
    label: 'Iceland',
    hemisphere: 0,
  },
  {
    id: 'IN',
    label: 'India',
    hemisphere: 0,
  },
  {
    id: 'ID',
    label: 'Indonesia',
    hemisphere: 2,
  },
  {
    id: 'IR',
    label: 'Iran',
    hemisphere: 0,
  },
  {
    id: 'IQ',
    label: 'Iraq',
    hemisphere: 0,
  },
  {
    id: 'IE',
    label: 'Ireland',
    hemisphere: 0,
  },
  {
    id: 'IL',
    label: 'Israel',
    hemisphere: 0,
  },
  {
    id: 'IT',
    label: 'Italy',
    hemisphere: 0,
  },
  {
    id: 'JM',
    label: 'Jamaica',
    hemisphere: 0,
  },
  {
    id: 'JP',
    label: 'Japan',
    hemisphere: 0,
  },
  {
    id: 'JO',
    label: 'Jordan',
    hemisphere: 0,
  },
  {
    id: 'KZ',
    label: 'Kazakhstan',
    hemisphere: 0,
  },
  {
    id: 'KE',
    label: 'Kenya',
    hemisphere: 0,
  },
  {
    id: 'KI',
    label: 'Kiribati',
    hemisphere: 2,
  },
  {
    id: 'KW',
    label: 'Kuwait',
    hemisphere: 0,
  },
  {
    id: 'KG',
    label: 'Kyrgyzstan',
    hemisphere: 0,
  },
  {
    id: 'LA',
    label: 'Laos',
    hemisphere: 0,
  },
  {
    id: 'LV',
    label: 'Latvia',
    hemisphere: 0,
  },
  {
    id: 'LB',
    label: 'Lebanon',
    hemisphere: 0,
  },
  {
    id: 'LS',
    label: 'Lesotho',
    hemisphere: 1,
  },
  {
    id: 'LR',
    label: 'Liberia',
    hemisphere: 0,
  },
  {
    id: 'LY',
    label: 'Libya',
    hemisphere: 0,
  },
  {
    id: 'LI',
    label: 'Liechtenstein',
    hemisphere: 0,
  },
  {
    id: 'LT',
    label: 'Lithuania',
    hemisphere: 0,
  },
  {
    id: 'LU',
    label: 'Luxembourg',
    hemisphere: 0,
  },
  {
    id: 'MK',
    label: 'Macedonia',
    hemisphere: 0,
  },
  {
    id: 'MG',
    label: 'Madagascar',
    hemisphere: 0,
  },
  {
    id: 'MW',
    label: 'Malawi',
    hemisphere: 1,
  },
  {
    id: 'MY',
    label: 'Malaysia',
    hemisphere: 2,
  },
  {
    id: 'MV',
    label: 'Maldives',
    hemisphere: 0,
  },
  {
    id: 'ML',
    label: 'Mali',
    hemisphere: 0,
  },
  {
    id: 'MT',
    label: 'Malta',
    hemisphere: 0,
  },
  {
    id: 'MH',
    label: 'Marshall Islands',
    hemisphere: 1,
  },
  {
    id: 'MR',
    label: 'Mauritania',
    hemisphere: 0,
  },
  {
    id: 'MU',
    label: 'Mauritius',
    hemisphere: 0,
  },
  {
    id: 'MX',
    label: 'Mexico',
    hemisphere: 0,
  },
  {
    id: 'FM',
    label: 'Micronesia',
    hemisphere: 1,
  },
  {
    id: 'MD',
    label: 'Moldova',
    hemisphere: 0,
  },
  {
    id: 'MC',
    label: 'Monaco',
    hemisphere: 0,
  },
  {
    id: 'MN',
    label: 'Mongolia',
    hemisphere: 1,
  },
  {
    id: 'ME',
    label: 'Montenegro',
    hemisphere: 0,
  },
  {
    id: 'MA',
    label: 'Morocco',
    hemisphere: 0,
  },
  {
    id: 'MZ',
    label: 'Mozambique',
    hemisphere: 1,
  },
  {
    id: 'MM',
    label: 'Myanmar',
    hemisphere: 0,
  },
  {
    id: 'NA',
    label: 'Namibia',
    hemisphere: 1,
  },
  {
    id: 'NR',
    label: 'Nauru',
    hemisphere: 1,
  },
  {
    id: 'NP',
    label: 'Nepal',
    hemisphere: 0,
  },
  {
    id: 'NL',
    label: 'Netherlands',
    hemisphere: 0,
  },
  {
    id: 'NZ',
    label: 'New Zealand',
    hemisphere: 1,
  },
  {
    id: 'NI',
    label: 'Nicaragua',
    hemisphere: 0,
  },
  {
    id: 'NE',
    label: 'Niger',
    hemisphere: 0,
  },
  {
    id: 'NG',
    label: 'Nigeria',
    hemisphere: 0,
  },
  {
    id: 'KP',
    label: 'North Korea',
    hemisphere: 0,
  },
  {
    id: 'NO',
    label: 'Norway',
    hemisphere: 0,
  },
  {
    id: 'OM',
    label: 'Oman',
    hemisphere: 0,
  },
  {
    id: 'PK',
    label: 'Pakistan',
    hemisphere: 0,
  },
  {
    id: 'PW',
    label: 'Palau',
    hemisphere: 1,
  },
  {
    id: 'PS',
    label: 'Palestine',
    hemisphere: 0,
  },
  {
    id: 'PA',
    label: 'Panama',
    hemisphere: 0,
  },
  {
    id: 'PG',
    label: 'Papua New Guinea',
    hemisphere: 1,
  },
  {
    id: 'PY',
    label: 'Paraguay',
    hemisphere: 1,
  },
  {
    id: 'PE',
    label: 'Peru',
    hemisphere: 1,
  },
  {
    id: 'PH',
    label: 'Philippines',
    hemisphere: 0,
  },
  {
    id: 'PL',
    label: 'Poland',
    hemisphere: 0,
  },
  {
    id: 'PT',
    label: 'Portugal',
    hemisphere: 0,
  },
  {
    id: 'QA',
    label: 'Qatar',
    hemisphere: 0,
  },
  {
    id: 'RO',
    label: 'Romania',
    hemisphere: 0,
  },
  {
    id: 'RU',
    label: 'Russia',
    hemisphere: 0,
  },
  {
    id: 'RW',
    label: 'Rwanda',
    hemisphere: 0,
  },
  {
    id: 'KN',
    label: 'Saint Kitts and Nevis',
    hemisphere: 0,
  },
  {
    id: 'LC',
    label: 'Saint Lucia',
    hemisphere: 0,
  },
  {
    id: 'VC',
    label: 'Saint Vincent and the Grenadines',
    hemisphere: 0,
  },
  {
    id: 'WS',
    label: 'Samoa',
    hemisphere: 1,
  },
  {
    id: 'SM',
    label: 'San Marino',
    hemisphere: 0,
  },
  {
    id: 'ST',
    label: 'Sao Tome and Principe',
    hemisphere: 0,
  },
  {
    id: 'SA',
    label: 'Saudi Arabia',
    hemisphere: 0,
  },
  {
    id: 'SN',
    label: 'Senegal',
    hemisphere: 0,
  },
  {
    id: 'RS',
    label: 'Serbia',
    hemisphere: 0,
  },
  {
    id: 'SC',
    label: 'Seychelles',
    hemisphere: 0,
  },
  {
    id: 'SL',
    label: 'Sierra Leone',
    hemisphere: 0,
  },
  {
    id: 'SG',
    label: 'Singapore',
    hemisphere: 0,
  },
  {
    id: 'SK',
    label: 'Slovakia',
    hemisphere: 0,
  },
  {
    id: 'SI',
    label: 'Slovenia',
    hemisphere: 0,
  },
  {
    id: 'SB',
    label: 'Solomon Islands',
    hemisphere: 1,
  },
  {
    id: 'SO',
    label: 'Somalia',
    hemisphere: 0,
  },
  {
    id: 'ZA',
    label: 'South Africa',
    hemisphere: 1,
  },
  {
    id: 'KR',
    label: 'South Korea',
    hemisphere: 1,
  },
  {
    id: 'SS',
    label: 'South Sudan',
    hemisphere: 0,
  },
  {
    id: 'ES',
    label: 'Spain',
    hemisphere: 0,
  },
  {
    id: 'LK',
    label: 'Sri Lanka',
    hemisphere: 0,
  },
  {
    id: 'SD',
    label: 'Sudan',
    hemisphere: 0,
  },
  {
    id: 'SR',
    label: 'Suriname',
    hemisphere: 0,
  },
  {
    id: 'SZ',
    label: 'Swaziland',
    hemisphere: 1,
  },
  {
    id: 'SE',
    label: 'Sweden',
    hemisphere: 0,
  },
  {
    id: 'CH',
    label: 'Switzerland',
    hemisphere: 0,
  },
  {
    id: 'SY',
    label: 'Syria',
    hemisphere: 0,
  },
  {
    id: 'TW',
    label: 'Taiwan',
    hemisphere: 0,
  },
  {
    id: 'TJ',
    label: 'Tajikistan',
    hemisphere: 0,
  },
  {
    id: 'TZ',
    label: 'Tanzania',
    hemisphere: 0,
  },
  {
    id: 'TH',
    label: 'Thailand',
    hemisphere: 0,
  },
  {
    id: 'TG',
    label: 'Togo',
    hemisphere: 0,
  },
  {
    id: 'TO',
    label: 'Tonga',
    hemisphere: 1,
  },
  {
    id: 'TT',
    label: 'Trinidad and Tobago',
    hemisphere: 0,
  },
  {
    id: 'TN',
    label: 'Tunisia',
    hemisphere: 0,
  },
  {
    id: 'TR',
    label: 'Turkey',
    hemisphere: 0,
  },
  {
    id: 'TM',
    label: 'Turkmenistan',
    hemisphere: 0,
  },
  {
    id: 'TV',
    label: 'Tuvalu',
    hemisphere: 1,
  },
  {
    id: 'UG',
    label: 'Uganda',
    hemisphere: 0,
  },
  {
    id: 'UA',
    label: 'Ukraine',
    hemisphere: 0,
  },
  {
    id: 'AE',
    label: 'United Arab Emirates',
    hemisphere: 0,
  },
  {
    id: 'GB',
    label: 'United Kingdom',
    hemisphere: 0,
  },
  {
    id: 'US',
    label: 'United States',
    hemisphere: 0,
  },
  {
    id: 'UY',
    label: 'Uruguay',
    hemisphere: 1,
  },
  {
    id: 'UZ',
    label: 'Uzbekistan',
    hemisphere: 0,
  },
  {
    id: 'VU',
    label: 'Vanuatu',
    hemisphere: 1,
  },
  {
    id: 'VA',
    label: 'Vatican City',
    hemisphere: 0,
  },
  {
    id: 'VE',
    label: 'Venezuela',
    hemisphere: 1,
  },
  {
    id: 'VN',
    label: 'Vietnam',
    hemisphere: 0,
  },
  {
    id: 'YE',
    label: 'Yemen',
    hemisphere: 0,
  },
  {
    id: 'ZM',
    label: 'Zambia',
    hemisphere: 1,
  },
  {
    id: 'ZW',
    label: 'Zimbabwe',
    hemisphere: 1,
  },
];
